import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  CollectionQuery,
  CollectionQueryResult,
} from "../../../generated/gql/graphql";

const GET_SHARED_COLLECTIONS = gql`
  query SharedCollections($userId: String!, $query: SharedCollectionQuery) {
    sharedCollections(userId: $userId, query: $query) {
      items {
        id
        status
        sort
        name
        image
        userId
        sharedUserIds
        dateCreated
        dateUpdated
        createdBy
      }
    }
  }
`;

export default function useSharedCollections(
  userId: string,
  query?: CollectionQuery
): QueryResult<CollectionQueryResult> {
  return useQuery<CollectionQueryResult>(GET_SHARED_COLLECTIONS, {
    variables: {
      userId,
      query,
    },
  });
}
